
import { initRestaurantsMapBrands } from "./../js/restaurantsMapBrands/initRestaurantsMapBrands.jsx";

initRestaurantsMapBrands("restaurants-map-brands");
